export const hu = {
    languages: {
        cs: 'Cseh',
        de: 'Német',
        en: 'Angol',
        es: 'Spanyol',
        fr: 'Francia',
        hr: 'Horvát',
        hu: 'Magyar',
        it: 'Olasz',
        nl: 'Holland',
        pl: 'Lengyel',
        ru: 'Orosz',
        sk: 'Szlovák',
        tr: 'Török',
        uk: 'Ukrán',
        undefined: 'Nincs felirat',
    },
    player: {
        content: {
            notFound: { title: 'Hiba történt a médiaelem betöltése közben 😞' },
        },
        controls: {
            backwards: { title: '10s vissza' },
            buffering: { title: 'Betöltés...' },
            captions: { title: 'Feliratok' },
            forwards: { title: '10s előre' },
            fullscreen: { title: 'Teljes képernyő' },
            pause: { title: 'Szünet' },
            play: { title: 'Lejátszás' },
            playlist: { title: 'Lejátszási lista' },
            volume: { title: 'Hangerő' },
        },
    },
};
